import * as React from "react";
import { forwardRef } from "react";
const SvgCheckSml = (props, ref) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 18 14", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M16 0L5.719 10.281 1.437 6 0 7.438l5 5 .719.687.718-.688 11-11z", fillRule: "nonzero", fill: "currentColor" }));
const ForwardRef = forwardRef(SvgCheckSml);
export default ForwardRef;
